import { render, staticRenderFns } from "./AdvancedChat.vue?vue&type=template&id=5387d3b5&scoped=true"
import script from "./AdvancedChat.vue?vue&type=script&lang=js"
export * from "./AdvancedChat.vue?vue&type=script&lang=js"
import style0 from "./AdvancedChat.vue?vue&type=style&index=0&id=5387d3b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387d3b5",
  null
  
)

export default component.exports